import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import './TechOptimized.css';

const TechOptimized = () => {
  return (
    <section className="tech-optimized">
      <div className="tech-optimized__inner">
        <Reveal className="tech-optimized__content">
          <h2 className="tech-optimized__title">
            Technology Optimized for Success.
          </h2>
          <p className="tech-optimized__text">
            Ready to experience our institutional-grade technology? Open an
            account today or contact our team for a setup walkthrough.
          </p>
          <Link to="/create-account" className="tech-optimized__cta luxury-btn">
            Become a Client
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default TechOptimized;
